import { useOrderStatus } from "@/api/orders";
import { usePaymentSquareStore } from "@/stores/payment-square.store";
import { useEffect, useState } from "react";

import { MdArrowRightAlt } from "react-icons/md";


const makeHash = (length: number) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function CheckoutOrderPaymentOnHold() {
  const setIsProcessingPayment = usePaymentSquareStore((state) => state.setProcessing);
  const checkoutId = usePaymentSquareStore((state) => state.checkoutId);
  const orderId = usePaymentSquareStore((state) => state.orderId);
  const [hash, setHash] = useState<string>(makeHash(10));

  const orderStatus = useOrderStatus({
    checkoutId: checkoutId ?? '',
    orderId: orderId ?? '',
  }, hash);

  useEffect(() => {
    const interval = setInterval(() => {
      setHash(makeHash(10));
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    console.log({orderStatus})
    if (orderStatus.data?.data?.status === 'COMPLETED') {
      setIsProcessingPayment(false);
    }
  }
  , [orderStatus.data?.data?.status]);

  return (
    <>
      <div
        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none print:hidden"
      >
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none p-10">
            <img src="/logo.png" className="w-80 m-auto" alt="app-logo" />
            <div className="flex justify-between flex-col items-center gap-5 p-5 rounded-t">
              <h3 className="text-3xl font-semibold text-center">
                Esperando pago...
              </h3>
              <h3 className="text-3xl font-semibold text-center">
                Paga con tarjeta en el datáfono a tu derecha
              </h3>
              <div className=" text-center w-full flex justify-center items-center">
              <MdArrowRightAlt className="text-[20rem] text-primary" />

              </div>

            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  )
}

export default CheckoutOrderPaymentOnHold